import {
  getPopularLocations,
  ResGetPopularLocations,
} from '@/service/tour/main/getPopularLocations';
import { useQuery } from '@tanstack/react-query';
import { RQMainKey } from './RQMainKey';

export const usePopularLocationsQuery = () => {
  return useQuery<ResGetPopularLocations, Error, ResGetPopularLocations['result']>({
    queryKey: RQMainKey.popularLocations,
    queryFn: getPopularLocations,
    select: (data) => data.result,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
  });
};
